<template>
  <div class="page">
      <h1>Shift Report</h1>
      <nav>
          <button @click="loadLines">Load Lines</button>
          <button @click="clearAccess">Clear Access</button>
          <button @click="clearAllTokens">Clear Tokens</button>
          <button @click="addNewLine">New Line</button>
      </nav>
      <ul>
          <li v-for="line in lines" :key="line.name">
              <h3>{{ line.name }}</h3>
              <p>{{ line.description }}</p>
              <button @click="editLine(line)">Edit</button><button @click="deleteLine(line)">Delete</button>
          </li>
      </ul>

      <div class="card" v-if="currentLine">
          <form>
              <div class="field">
                  <label for="line-name">Line Name</label>
                  <input type="text" name="line_name" v-model="currentLine.name" required />
              </div>
              <div class="field">
                  <label for="line-description">Line Description</label>
                  <input type="text" name="line_description" v-model="currentLine.description" />
              </div>
              <button class="primary button" @click.prevent="onSubmitLine" type="submit">Submit Line</button>

          </form>
      </div>
  </div>
</template>

<script>

export default {  
    
    props: {

    },

    mounted: function(){
        
    },

    data: function(){

        return {
            response: "",
            apiURL: "http://localhost:8888/",
            currentLine: null,
            lines: []
        }
    },
    methods: {

        editLine: function(line){
            this.currentLine = line;
        },

        deleteLine: function(line){
            this.$api.apiRequest('delete', 'lines/'+line.id)
            .then((response)=> {
                this.loadLines();
            })
             .catch((error) => {
                if(error.response){
                    console.log("error", error.response);
                }
            })
        },

        addNewLine: function(){
            this.currentLine = {
                name: "",
                description: ""
            }
        },

        onSubmitLine: function(){
            if(this.currentLine.id){
                this.updateLine();
            }else{
                
                this.createLine();
            }
        },

        updateLine: function(){
            this.$api.apiRequest('put','lines/'+this.currentLine.id+"/", this.currentLine)
            .then((response) => {

                if(response.response){
                    console.log("Error?");
                    console.log(response.response);
                }

                console.log("response successful", response);
            })
            .catch((error) => {
                if(error.response){
                    console.log("error", error.response);
                }
            })
        },

        createLine: function(){
            this.$api.apiRequest('post','lines/', this.currentLine)
            .then((response) => {

                if(response.response){
                    console.log("Error?");
                    console.log(response.response);
                }

                console.log("response successful", response);
            })
            .catch((error) => {
                if(error.response){
                    console.log("error", error.response);
                }
            })
        },


        clearAccess: function(){
            this.$api.clearAccessToken();
        },

        clearAllTokens: function(){
            this.$api.removeToken();
        },

        loadLines: function(){
            // this.$http.get(this.apiURL + "api/lines/").then((res) => {
            //     this.response = res;
            // }).catch((error)=>{
            //     if(error.response){
            //         console.log(error.response.status);
            //         this.$router.push("/");
            //     }else if(error.request){
            //         console.log(error.request);
            //     }else{
            //         console.log(error.config)
            //     }
            // })

            // this.requestLines().then((data)=>{
            //     console.log("request lines...", data);
            // })

            this.$api.apiRequest("get", "lines").then((response) => {
                console.log("final response", response)
                if(response.success && response.success.data){
                    this.lines = response.success.data.results; 
                }else{
                    if(response.error, response.error.status){
                        alert(response.error.statusText);
                    }
                    this.$router.push({name: "login"});
                }

                
                
            })
            .catch((error) => {
                console.log(error);
                alert("System Error.");
            })

            
        },
    }

       
}
</script>

<style>

</style>
